import { ClassBookFolder } from './class-book-folder.model';
import { ClassBookFolderInterface } from './class-book-folder.interface';

export class ClassBookFolderFactory {

    static empty(): ClassBookFolder {
        return new ClassBookFolder('', '', '', 0);
    }

    static fromObject(raw: ClassBookFolderInterface | any): ClassBookFolder {
        if (raw.success === false) {
            throw new Error(raw.message);
        }
        return new ClassBookFolder(
            raw.id,
            raw.name,
            raw.description,
            raw.order,
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/settings/class-book-folders/shared/class-book-folder.factory.ts